// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed834c94","453":"01262911","455":"523b3afd"}[chunkId] + ".chunk.js";
};